import { Middleware } from 'redux';

/**
 * A middleware function that is used in place of the logging middleware when not in devMode.
 */

const noOpMiddleware: Middleware = () => (next) => (action) => next(action);

export default noOpMiddleware;
